
export default function About() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/e846cd13ad50f045340828ba572ede33.jpg"
              alt="COOKIE DOO VRANJE VPN Development"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
          
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About COOKIE DOO VRANJE
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Based in Vranje, Serbia, COOKIE DOO VRANJE is a leading software development company specializing in creating innovative applications that enhance digital security and user experience. Our mission is to provide cutting-edge solutions that protect your online privacy and freedom.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our flagship VPN application represents the culmination of extensive research and development in cybersecurity technology. We are committed to delivering a product that combines robust security features with user-friendly design, ensuring that everyone can enjoy a safe and unrestricted internet experience.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              At COOKIE DOO VRANJE, we believe that online privacy is a fundamental right. That's why we've built our VPN with the highest security standards, implementing military-grade encryption and a strict no-logs policy to ensure your data remains completely private and secure.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-full mb-4">
                  <i className="ri-shield-check-fill text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Secure</h4>
                <p className="text-gray-600">Top-tier encryption protecting your data</p>
              </div>
              
              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-full mb-4">
                  <i className="ri-rocket-fill text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Fast</h4>
                <p className="text-gray-600">Optimized servers for maximum speed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
